import * as angular from "angular";
import {IQService} from "angular";

export class AgreementDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private $q:IQService, private agreementConstants) {
  }

  createAgreement(event) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope) {

        $scope.agreementTypes = self.agreementConstants.types;
        $scope.agreement = {
          type : '',
          name : '',
          latestVersion : {
            release : false,
            content : ''
          }
        };

        $scope.cancel = self.$mdDialog.cancel;

        $scope.ok = () => {
          self.$mdDialog.hide($scope.agreement);
        }
      },
      template: require('./../views/dialogs/create-agreement-dialog.html').default,
      parent : angular.element(document.body),
      targetEvent : event,
      clickOutsideToClose : true
    });
  }

  editAgreementVersion(event, agreement) {
    const self = this;
    return this.$mdDialog.show({
      controller:function ($scope) {

        $scope.agreementTypes = self.agreementConstants.types;
        $scope.agreement = agreement;
        $scope.version = angular.copy(agreement.latestVersion);

        $scope.cancel = self.$mdDialog.cancel;

        $scope.ok = () => {
          self.$mdDialog.hide($scope.version);
        }
      },
      template: require('./../views/dialogs/create-agreement-dialog.html').default,
      parent : angular.element(document.body),
      targetEvent : event,
      clickOutsideToClose : true
    });
  }

}


angular
  .module('bringoz.admin.agreements')
  .service('agreementDialogService', AgreementDialogService);
